import { useCallback, useMemo } from "react";
import { useAppStore } from "../store/store";

export function getAnswerForPage(questions, questionId) {
  const question = questions?.find?.((q) => q.questionId === questionId);
  if (!question) return "";
  return question.answerKey || "";
}
export function useAnswer(screenId) {
  const { form, setAnswer } = useAppStore();

  const answer = useMemo(
    () => getAnswerForPage(form.questions, screenId),
    [form.questions, screenId],
  );
  const handleSetAnswer = useCallback(
    (newAnswer) => setAnswer(screenId, newAnswer),
    [screenId, setAnswer],
  );

  return { answer, setAnswer: handleSetAnswer };
}
